import React from "react";
import Dropzone from "react-dropzone";
import { IMAGES } from "src/assests";

interface ImageUploadProps {
  imageUrl?: string;
  onImageChange: (file: File) => void;
  className?: string;
  /** Compact header variant: 80x80 square with "Change" link */
  compact?: boolean;
  /** Inline row variant: 60px square, pencil overlay only, no label/text. Use in form row. */
  inline?: boolean;
}

const ImageUpload: React.FC<ImageUploadProps> = ({
  imageUrl,
  onImageChange,
  className = "",
  compact = false,
  inline = false,
}) => {
  return (
    <Dropzone
      accept={{
        "image/png": [".png"],
        "image/jpg": [".jpg"],
        "image/jpeg": [".jpeg"],
      }}
      onDrop={(acceptedFiles) => {
        if (acceptedFiles.length > 0) {
          onImageChange(acceptedFiles[0]);
        }
      }}
    >
      {({ getRootProps, getInputProps }) => (
        <div className={`relative ${className}`}>
          {inline ? (
            <div
              className="group relative w-[60px] h-[60px] rounded-lg bg-[#E5E7EB] overflow-hidden border border-[#E5E7EB] hover:border-[#D1D5DB] transition-colors cursor-pointer flex-shrink-0"
              title="Change image"
              {...getRootProps()}
            >
              <input {...getInputProps()} />
              <img
                src={imageUrl || IMAGES.DefaultEditItemImage}
                alt=""
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity">
                <img
                  src={IMAGES.PencilImage}
                  alt=""
                  className="w-5 h-5 brightness-0 invert drop-shadow"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </div>
          ) : compact ? (
            <div
              className="flex flex-col items-center gap-1 cursor-pointer"
              {...getRootProps()}
            >
              <input {...getInputProps()} />
              <div className="w-20 h-20 rounded-lg bg-[#E5E7EB] flex justify-center items-center overflow-hidden border border-[#E5E7EB] hover:border-[#D1D5DB] transition-colors">
                <img
                  src={imageUrl || IMAGES.DefaultEditItemImage}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-xs text-[#6b7280] hover:text-[#374151]">
                Change
              </span>
            </div>
          ) : (
            <>
              <div
                className="w-[67px] h-[67px] rounded-[8px] bg-[#C4C4C4] flex justify-center items-center cursor-pointer"
                {...getRootProps()}
              >
                <img
                  src={imageUrl || IMAGES.DefaultEditItemImage}
                  alt=""
                  className="w-[32.25] h-[32.25] object-cover"
                />
                <input {...getInputProps()} />
              </div>
              <button
                type="button"
                className="absolute -top-2 -right-1 bg-white rounded-full flex items-center justify-center"
                {...getRootProps()}
              >
                <img
                  src={IMAGES.PencilImage}
                  alt="Edit"
                  className="w-6 h-6"
                />
                <input {...getInputProps()} />
              </button>
            </>
          )}
        </div>
      )}
    </Dropzone>
  );
};

export default ImageUpload;

